class CustomProduct extends HTMLElement {
    constructor() {
      super();
      this.selectedVariantId = null;
      this.buttonAddToCart = document.querySelector(".product-form__submit");
      this.addToCartButton = document.querySelector(".button-add-to-cart");
    }
  
    connectedCallback() {
      const tabs = this.querySelectorAll(".product-tab");
      const variants = this.querySelectorAll(".product-variants");
      const variantInput = document.querySelector("#product-variant-id");
      const benefitsSections = document.querySelectorAll(".product-benefits-content");
      const productFaq = document.querySelectorAll(".product-faq");
  
      if (variants.length > 0) {
        variants[0].classList.add("active");
        tabs[0].classList.add("active");
        this.selectFirstVariant(variants[0], variantInput);
      }
  
      tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const productId = tab.getAttribute("data-product-id");
          tabs.forEach((t) => t.classList.remove("active"));
          variants.forEach((v) => v.classList.remove("active"));
          benefitsSections.forEach((section) =>section.classList.remove("active"));
          productFaq.forEach((faq) => {
            faq.classList.toggle("active",faq.getAttribute("data-product-id") === productId);
          });
  
          let activeBenefits;
          const activeVariantsSection = this.querySelector(`#variants-${productId}`);
          activeVariantsSection.classList.add("active");
          tab.classList.add("active");
          this.selectFirstVariant(activeVariantsSection, variantInput, true);          
          let variantID = activeVariantsSection.querySelector(".variant-item.selected").getAttribute("data-product-id");
  
          if (tab.classList.contains("collection")) {
            productFaq.forEach((faq) => {
              if (faq.getAttribute("data-product-id") === variantID) {
                faq.classList.add("active");
              } else {
                faq.classList.remove("active");
              }
            });
          }
  
          activeBenefits = document.querySelectorAll(`.product-benefits-content[data-product-id="${productId}"]`);
          if (!activeBenefits.length) {
            activeBenefits = document.querySelectorAll(`.product-benefits-content[data-product-id="${activeVariantsSection.querySelector(".selected").getAttribute("data-product-id")}"]`);
          }
          activeBenefits.forEach((section) => section.classList.add("active"));
          const backgroundColorVariant = activeVariantsSection.querySelector(".selected").getAttribute("data-background-color");
          const transitionOverlay = document.querySelector("#transitionOverlay");
          transitionOverlay.classList.add("opacity-1");
          transitionOverlay.classList.add("visibility-visible");
          this.updateBakgroundColor(activeVariantsSection,backgroundColorVariant);
  
          const benefitActive = document.querySelectorAll(".product-benefits-content.active");
          benefitActive.forEach((ele) => {
            const productbenefitsEle = ele.querySelectorAll(".product-benefits");
            productbenefitsEle.forEach((benefit) => {
              benefit.style.backgroundColor = backgroundColorVariant;
            });
          });
        });
      });
      this.addVariantSelectionListeners(variants, variantInput);
    }
  
    selectFirstVariant(variantsSection, variantInput, selected) {
      const firstVariant = variantsSection.querySelector(".variant-item");
      if (firstVariant) {
        this.updateSelectedVariant(firstVariant, variantInput, selected);
      }
    }
  
    addVariantSelectionListeners(variants, variantInput) {
      variants.forEach((variantSection) => {
        const variantItems = variantSection.querySelectorAll(".variant-item");
        variantItems.forEach((variantItem) => {
          variantItem.addEventListener("click", () => {
            if (!variantItem.classList.contains("selected")) {  
              const variant_handle = variantItem.getAttribute("data-product-handle");
              const transitionOverlay = document.querySelector("#transitionOverlay");
              transitionOverlay.classList.add("opacity-1");
              transitionOverlay.classList.add("visibility-visible");
              const backgroundColorVariant = variantItem.getAttribute("data-background-color");
              const backgroundColor = `${backgroundColorVariant.slice(0,-1)}, 0.7)`;
              this.updateSelectedVariant(variantItem, variantInput, true);  
              this.updateBakgroundColor(variantItem, backgroundColorVariant);
  
              const selectedElement = document.querySelector(".variant-item.selected");
              const benefitActive = document.querySelectorAll(".product-benefits-content.active");
              benefitActive.forEach((ele) => {
                const productbenefitsEle = ele.querySelectorAll(".product-benefits");
                productbenefitsEle.forEach((benefit) => {
                  benefit.style.backgroundColor = backgroundColorVariant;
                });
              });
  
              if (!selectedElement.parentElement.parentElement.classList.contains("custom_product")) {
                document.querySelectorAll(".product-benefits-content").forEach((section) => section.classList.remove("active"));
                const productFaq = document.querySelectorAll(".product-faq");
  
                let activeBenefits = document.querySelectorAll(`.product-benefits-content[data-product-id="${selectedElement.getAttribute("data-product-id")}"]`);
                activeBenefits.forEach((section) =>
                  section.classList.add("active")
                );
                const benefitActive = document.querySelectorAll(".product-benefits-content.active");
                benefitActive.forEach((ele) => {
                  const productbenefitsEle = ele.querySelectorAll(".product-benefits");
                  productbenefitsEle.forEach((benefit) => {
                    benefit.style.backgroundColor = backgroundColorVariant;
                  });
                });
  
                productFaq.forEach((faq) => {
                  if (faq.getAttribute("data-product-id") === selectedElement.getAttribute("data-product-id")) {
                    faq.classList.add("active");
                  } else {
                    faq.classList.remove("active");
                  }
                });
              }
              transitionOverlay.classList.add("transition-added");
  
              setTimeout(() => {
                transitionOverlay.classList.remove("transition-added");
                transitionOverlay.classList.remove("opacity-1");
                transitionOverlay.classList.remove("visibility-visible");
              }, 1000);
            }
          });
        });
      }); 
    }  
    updateSelectedVariant(variantItem, variantInput, selected) {   

    const isProductTab = document.querySelector(".product-tab.product-option-tab.product.active");
    if (isProductTab) {      
      const activeVariantWrapper = document.querySelector(".custom_product.active .custom-product-variant-wrapper");
          
      if (activeVariantWrapper) {
        const updateSelectedVariantData = () => {
          const selectedItems = activeVariantWrapper.querySelectorAll(".variant-item.selected");
      
          let styleOption = null;
          let sizeOption = null;
      
          selectedItems.forEach((selected) => {
            if (selected.dataset.optionStyle) {
              styleOption = selected.dataset.optionStyle;
            }
            if (selected.dataset.optionSize) {
              sizeOption = selected.dataset.optionSize;
            }
          });
      
          if (styleOption && sizeOption) {
            const selectEl = document.getElementById("variant-select");
            const options = selectEl ? selectEl.querySelectorAll("option") : [];
      
            let matchFound = false;
            let matchedOption = null;
      
            options.forEach((opt) => {
              const styleAttr = opt.dataset.styleOption;
              const sizeAttr = opt.dataset.sizeOption;
      
              if (styleAttr === styleOption && sizeAttr === sizeOption) {
                matchFound = true;
                matchedOption = opt;
              }
            });
      
            if (matchFound && matchedOption) {      
              // Extract from matched <option>
              const variantId = matchedOption.dataset.variantId || "";
              const inventory = matchedOption.dataset.inventory || "";
              const available = matchedOption.dataset.variantAvailable || "";
              const bgColor = matchedOption.dataset.backgroundColor || "";
              const variantUrl = matchedOption.dataset.variantUrl || "";
      
              // Update each .selected variant item
              selectedItems.forEach((selected) => {
                selected.dataset.variantId = variantId;
                selected.dataset.inventory = inventory;
                selected.dataset.available = available;
                selected.dataset.backgroundColor = bgColor;
                selected.dataset.productHandle = variantUrl;
              }); 

              // Update image on each size-variant-item based on selected style              
              const sizeItems = activeVariantWrapper.querySelectorAll(".variant-item.size-variant-item");

              sizeItems.forEach((sizeItem) => {
                const size = sizeItem.dataset.optionSize;
                options.forEach((opt) => {
                  const styleAttr = opt.dataset.styleOption;
                  const sizeAttr = opt.dataset.sizeOption;

                  if (styleAttr === styleOption && sizeAttr === size) {
                    const variantImage = opt.dataset.variantImage || "";

                    const imageWrapper = sizeItem.querySelector(".variant-image-wrapper img");
                    if (imageWrapper && variantImage) {
                      imageWrapper.src = variantImage;
                    }
                  }
                });
              });
              this.updateBakgroundColor(selectedItems,bgColor);

              // Also update image on each style-variant-item based on its own style match
              const styleItems = activeVariantWrapper.querySelectorAll(".variant-item[data-option-style]");

              styleItems.forEach((styleItem) => {
                const styleValue = styleItem.dataset.optionStyle;

                options.forEach((opt) => {
                  const styleAttr = opt.dataset.styleOption;
                  const variantImage = opt.dataset.variantImage || "";

                  if (styleAttr === styleValue && variantImage) {
                    const imageEl = styleItem.querySelector(".variant-image-wrapper img");
                    if (imageEl) {
                      imageEl.src = variantImage;
                      imageEl.alt = styleValue;
                    }
                  }
                });
              });              
              // if (variantInput) variantInput.value = variantId;
              this.selectedVariantId = variantId;

              const inventoryAvailable = available === "true";              
              if (this.addToCartButton) {
                this.addToCartButton.textContent = inventoryAvailable ? "Add to Cart" : "Sold Out";
                this.buttonAddToCart.toggleAttribute("disabled", !inventoryAvailable);                              
              }
              
            } else {
              console.log("not matched");
            }
          }
        };
      
        activeVariantWrapper.querySelectorAll(".variants-wrapper").forEach((wrapper) => {
          const firstItem = wrapper.querySelector(".variant-item");
      
          if (firstItem && !wrapper.querySelector(".variant-item.selected")) {
            firstItem.classList.add("selected");
          }
      
          wrapper.querySelectorAll(".variant-item").forEach((item) => {
            item.addEventListener("click", () => {
              wrapper.querySelectorAll(".variant-item").forEach((el) => el.classList.remove("selected"));
              item.classList.add("selected");
      
              // Update data after selection
              updateSelectedVariantData();
              this.updateInfo(selected);
            });
          });
        });
      
        // Run data update on page load
        updateSelectedVariantData();
        this.updateInfo(selected);   
      }   
      
       
    }else{         
        document.querySelectorAll(".variant-item").forEach((item) =>
          item.classList.remove("selected")
        );
        variantItem.classList.add("selected");
        this.updateInfo(selected);
      } 
  
      const variantId = variantItem.getAttribute("data-variant-id");
      
      variantInput.value = variantId;
      this.selectedVariantId = variantId;
  
      const inventoryAvailable =
        variantItem.getAttribute("data-available") === "true";
      if (this.addToCartButton) {this.addToCartButton.textContent = inventoryAvailable
          ? "Add to Cart"
          : "Sold Out";
        this.buttonAddToCart.toggleAttribute("disabled", !inventoryAvailable);        
      }
    }
    updateBakgroundColor(variantItem, backgroundColor) {
      document.documentElement.style.setProperty("--after-color",backgroundColor);  
      const isProductTable = document.querySelector(".product-tab.product-option-tab.product.active");

      let variantImageWrapper;
      let variantImageWrapperText;

      if (isProductTable) {
        const selectedStyleItem = document.querySelector(".variant-item.style-variant-item.selected");
        if (selectedStyleItem) {
          variantImageWrapper = selectedStyleItem.querySelector(".variant-image-wrapper");
          variantImageWrapperText = selectedStyleItem.querySelector(".variant-image-wrapper-text");
        }
      } else {
        variantImageWrapper = variantItem.querySelector(".variant-image-wrapper");
        variantImageWrapperText = variantItem.querySelector(".variant-image-wrapper-text");
      }         
      
  
      if (variantImageWrapper || variantImageWrapperText) {
        const transitionOverlaySvg = document.querySelector(".transition-overlay-svg");
        const transitionOverlay = document.querySelector("#transitionOverlay");
        const checkoutElement = document.querySelectorAll("shopify-accelerated-checkout");
        if (checkoutElement) {
          checkoutElement.forEach((ele) => {
            ele.style.backgroundColor = backgroundColor;
          })          
        }
        document.querySelectorAll(".product-form__submit").forEach((product) => {
          product.style.backgroundColor = backgroundColor;
        });
        
        document.querySelectorAll(".price-per-item__container .quantity").forEach((btn) => {
            btn.style.backgroundColor = backgroundColor;
          });
        document.querySelector(".product-tab.active").style.backgroundColor = "white";
        document.querySelectorAll(".product-tab:not(.active)").forEach((tab) => {
          tab.style.backgroundColor = backgroundColor;
        });
        document.querySelectorAll(".cusom-form-label").forEach((label) => {
          label.style.backgroundColor = backgroundColor;              
        });
        const sectionMainProductWrapper =
          document.querySelector(".section-wrapper");
        function rgbaToRgb(r, g, b, a, bgColor = { r: 255, g: 255, b: 255 }) {
          // Blend the foreground (r, g, b, a) with the background (bgColor)
          const newR = Math.round((1 - a) * bgColor.r + a * r);
          const newG = Math.round((1 - a) * bgColor.g + a * g);
          const newB = Math.round((1 - a) * bgColor.b + a * b);
          return `rgb(${newR}, ${newG}, ${newB})`;
        }
  
        function addOpacityToRgb(
          rgb,
          opacity = 0.7,
          bgColor = { r: 255, g: 255, b: 255 }
        ) {
          // Parse the input RGB color
          const match = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
          if (!match) throw new Error("Invalid RGB color format");
  
          const [_, r, g, b] = match.map(Number);
          return rgbaToRgb(r, g, b, opacity, bgColor);
        }
  
        // Example usage
        const inputRgb = backgroundColor;
        const result = addOpacityToRgb(inputRgb); 
        backgroundColor = result; 
  
        if (backgroundColor) {
          transitionOverlay.classList.add("transition-added");
          transitionOverlaySvg.style.fill = backgroundColor;
          transitionOverlay.style.backgroundColor = backgroundColor;          
  
          setTimeout(() => {
            transitionOverlay.classList.remove("transition-added");
            transitionOverlay.classList.remove("opacity-1");
            transitionOverlay.classList.remove("visibility-visible");
          }, 1000);
          setTimeout(() => {
            sectionMainProductWrapper.style.backgroundColor = backgroundColor;
          }, 1000);
        }
      }
    }
  
    updateInfo(selected) {      
      const selectedProduct = document.querySelector(".variant-item.selected");
      const selectedProductHandle = selectedProduct.getAttribute("data-product-handle");      
      const bgColor = selectedProduct.getAttribute("data-background-color");

      window.addEventListener("load", () => init);
        init();

        function init() {
        Array.from(document.querySelectorAll("[data-variant-id]")).forEach((node) => {
            node.addEventListener("click", () => {
            console.log(node.getAttribute("data-variant-id"))
            VariantDescriptionApp.setDescription(node.getAttribute("data-variant-id"))
            })
        })
        }
  
      fetch(selectedProductHandle)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");                   
          
          document.querySelector("media-gallery").innerHTML = doc.querySelector("media-gallery").innerHTML;
          document.querySelector("product-gallery img").style.backgroundColor = bgColor;
  
          if (selectedProduct.parentElement.parentElement.classList.contains("custom_product") &&
          !selectedProduct.parentElement.parentElement.classList.contains("default-variant-product")) {
            document.querySelector("carousel-sync").classList.add("d-none");
          }
  
          document.querySelectorAll(".product__title h1").forEach((title) => {
            title.innerHTML = doc.querySelector(".product__title h1").innerHTML;
          });
  
          document.querySelectorAll(".price-container-wrapper").forEach((price) => {
              price.innerHTML = doc.querySelector(
                ".price-container-wrapper"
              ).innerHTML;
            });
  
          const newProductForm = doc.querySelector("product-form");
          
          const productFormQuantity = doc.querySelector(".product-form__quantity");          
  
          if (!selectedProductHandle.includes("/bumbum-gift-card")) {            
            newProductForm.classList.remove('original-button')
            newProductForm.classList.add('dummy-button')
            newProductForm.querySelector('.product-form__submit').style.backgroundColor = bgColor;
            document.querySelector('.dummy-button').replaceWith(newProductForm);
            document.querySelector('.dummy-button').style.display = 'block'
            document.querySelector('.original-button').style.display = 'none' 
            if (newProductForm && newProductForm.querySelector('.baby-custom-fields')) {
              initBabyFieldsValidation();            
            }           
           
               
          } else {                  
          document.querySelector('.dummy-button').style.display = 'none'
          document.querySelector('.original-button').style.display = 'block'  
          if (doc && doc.querySelector('.baby-custom-fields')) {
            initBabyFieldsValidation();   
          }         
          
          }
          document.querySelector('.product-form__quantity').replaceWith(productFormQuantity);
          document.querySelectorAll("shopify-accelerated-checkout").forEach((btn) => {
            btn.style.backgroundColor = bgColor;
          })
          document.querySelector(".product-form__submit").style.backgroundColor = bgColor;
          document.querySelectorAll(".price-per-item__container .quantity").forEach((btn) => {
              btn.style.backgroundColor = bgColor;
            });
  
          document.querySelector(".product-tab.active").style.backgroundColor = "white";
          document.querySelectorAll(".product-tab:not(.active)").forEach((tab) => {
              tab.style.backgroundColor = bgColor;              
            });  
          document.querySelectorAll(".cusom-form-label").forEach((label) => {
            label.style.backgroundColor = bgColor;              
          });
              
              
        })
        .catch((error) => console.error("Error fetching product info:", error))
        .finally(() => {
          document
            .querySelector(".section-wrapper")
            .classList.remove("g-is-loading");
  
          setTimeout(() => {
            // Select all elements with the class 'product-tab'
            const productTabs = document.querySelectorAll(".product-tab");
  
            // Loop through each element and remove the pointer-events style
            productTabs.forEach((tab) => {
              tab.style.pointerEvents = "all"; // Remove the pointer-events style or set it to none
            });
          }, 1000);
        });
    }
  }
  customElements.define("custom-product", CustomProduct);  